export { createPlatformView } from './createPlatformView';
